import { Backdrop, CircularProgress } from "@mui/material";

export default function LoadingOverlay() {
    return (
        <Backdrop open sx={(theme) => ({ zIndex: theme.zIndex.snackbar + 1 })}>
            <CircularProgress data-test-id="loading_overlay" />
        </Backdrop>
    );
}
